import './index.scss'
import rateHtml from './index.html'
import { parseDom } from 'src/frontend-lib/tools/domUtil'

/**
 * 倍速播放组件
 */
export default class RateComponent {
  /**
   * @constructor 倍速播放组件构造函数
   */
  constructor() {
    this.html = parseDom(rateHtml)
  }

  createEl(el) {
    let eleControlbar = el.querySelector('.prism-controlbar')
    eleControlbar.appendChild(this.html)
  }

  ready(player, e) {
    let currentRateEle = this.html.querySelector('.current-rate')
    let rateListEle = this.html.querySelector('.rate-list')
    let timeId = null

    // 隐藏设置里面的倍速播放
    let settingRate = document.querySelector(
      '.prism-setting-item.prism-setting-speed'
    )
    if (settingRate) {
      settingRate.classList.add('player-hidden')
    }

    const hide = () => {
      timeId = window.setTimeout(() => {
        rateListEle.style.display = 'none'
      }, 100)
    }

    currentRateEle.onclick = () => {
      rateListEle.style.display = 'block'
    }
    currentRateEle.onmouseleave = hide

    rateListEle.onmouseenter = () => {
      clearTimeout(timeId)
    }
    rateListEle.onmouseleave = hide

    player.on('touchstart', () => {
      clearTimeout(timeId)
    })
    player.on('touchend', ({ target }) => {
      if (target === rateListEle || target === currentRateEle) {
        return
      }
      hide()
    })

    rateListEle.onclick = ({ target }) => {
      let rate = target.dataset.rate
      if (rate) {
        player.setSpeed(rate)
        if (target.className !== 'current') {
          let currentEle = rateListEle.querySelector('.current')
          if (currentEle) {
            currentEle.className = ''
          }
          target.className = 'current'
        }
        rateListEle.style.display = 'none'
        currentRateEle.innerText = rate + 'x'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/RateComponent/index.js